import React from 'react';

/**
 * Componente que muestra el resumen de información básica
 */
const ResumenInformacionBasica = ({ 
  formData, 
  tipoEvaluacion, 
  tipoCargo, 
  cargosSeleccionados,
  onEdit,
  readOnly = false
}) => {
  return (
    <div className="card mb-4">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h6 className="mb-0">
          <i className="fas fa-info-circle me-2 text-primary"></i>
          Información Básica
        </h6>
        {!readOnly && (
          <button 
            type="button" 
            className="step4-btn-edit"
            onClick={() => onEdit(1)}
          >
            <i className="fas fa-edit me-1"></i>
            Editar
          </button>
        )}
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6">
            <div className="mb-3">
              <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
                Nombre de la Evaluación:
              </div>
              <p className="mb-1">{formData.nombreEvaluacion || <em className="text-muted">No especificado</em>}</p>
            </div>
            <div className="mb-3">
              <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
                Tipo de Evaluación:
              </div>
              <p className="mb-1">{tipoEvaluacion?.label || <em className="text-muted">No seleccionado</em>}</p>
            </div>
            <div className="mb-3">
              <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
                Tipo de Cargo:
              </div>
              <p className="mb-1">{tipoCargo?.label || <em className="text-muted">No seleccionado</em>}</p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="mb-3">
              <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
                Cargos Seleccionados ({formData.cargosSeleccionados.length}):
              </div>
              {cargosSeleccionados.length > 0 ? (
                <div className="step4-cargos-box mt-2">
                  <div className="step4-cargos-scroll" role="list" aria-label="Cargos seleccionados">
                    {cargosSeleccionados.map((cargo, idx) => (
                      <div key={idx} className="step4-cargo-item" role="listitem">
                        {cargo.label}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p className="mb-1"><em className="text-muted">Ninguno seleccionado</em></p>
              )}
            </div>
          </div>
        </div>
        
        <div className="mb-3">
          <div style={{ color: '#0063a1', fontWeight: '600', marginBottom: '8px' }}>
            Descripción del Encabezado:
          </div>
          <p className="mb-1" style={{whiteSpace: 'pre-wrap'}}>
            {formData.encabezadoDescripcion || <em className="text-muted">No especificada</em>}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ResumenInformacionBasica;
